import { CartProvider } from "./cart/CartContext";
import CartPage from "./pages/CartPage";
import OrderConfirmedPage from "./pages/OrderConfirmedPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import StorefrontPage from "./pages/StorefrontPage";

function decodePathSegment(value) {
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
}

function resolveRoute(pathname) {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] !== "commerce" || !segments[1]) return null;
  const storeSlug = decodePathSegment(segments[1]);
  if (!storeSlug) return null;

  if (segments.length === 2) {
    return { name: "catalog", storeSlug };
  }
  if (segments.length === 3 && segments[2] === "cart") {
    return { name: "cart", storeSlug };
  }
  if (segments.length === 3 && segments[2] === "order-confirmed") {
    return { name: "order-confirmed", storeSlug };
  }
  if (segments.length === 4 && segments[2] === "products") {
    const productHandle = decodePathSegment(segments[3]);
    if (productHandle) {
      return { name: "product", storeSlug, productHandle };
    }
  }
  return null;
}

export default function App() {
  const route = resolveRoute(window.location.pathname);

  if (!route) {
    return (
      <main className="route-error">
        <div className="route-error__mark">A</div>
        <h1>Endereço de loja inválido</h1>
        <p>
          Acesse uma loja usando o endereço{" "}
          <code>/commerce/nome-da-loja</code>.
        </p>
      </main>
    );
  }

  let page;
  if (route.name === "product") {
    page = (
      <ProductDetailPage
        storeSlug={route.storeSlug}
        productHandle={route.productHandle}
      />
    );
  } else if (route.name === "cart") {
    page = <CartPage storeSlug={route.storeSlug} />;
  } else if (route.name === "order-confirmed") {
    page = <OrderConfirmedPage storeSlug={route.storeSlug} />;
  } else {
    page = <StorefrontPage storeSlug={route.storeSlug} />;
  }

  return (
    <CartProvider storeSlug={route.storeSlug} key={route.storeSlug}>
      {page}
    </CartProvider>
  );
}
